<template>
  <div>
    <div class="block block-rounded block-fx-shadow">
        <div class="block-header">
            <h3 class="block-title"><i class="fas fa-coins"></i> {{ $t('debtors.debts') }}</h3>
            <div class="block-options">
              <b-btn v-b-modal.addDebt size="sm" variant="primary" class="float-right">{{ $t('debts.add') }}</b-btn>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-sm table-bordered">
                <thead>
                    <th>#</th>
                    <th>{{ $t('debts.number') }}</th>
                    <th>{{ $t('debts.amount_credit') }}</th>
                    <th>{{ $t('debts.current_arrears') }}</th>
                    <th>{{ $t('debts.delay_credit_day') }}</th>
                    <th>{{ $t('debts.category_day') }}</th>
                    <th>{{ $t('debts.start_date') }}</th>
                    <th>{{ $t('debts.end_date') }}</th>
                    <th>{{ $t('app.action') }}</th>
                </thead>
                <tbody>
                  <template v-if="!isProcessing">
                    <tr v-for="(debt, index) in debts" :key="debt.id">
                      <td>{{index+1}} </td>
                      <td>{{debt.number}} <span v-if="debt.deleted_at" class="badge badge-pill badge-danger">{{ $t('app.in_the_archive') }}</span></td>
                      <td>{{debt.amount_credit}}</td>
                      <td>{{debt.current_arrears}}</td>
                      <td>{{debt.delay_credit_day}}</td>
                      <td>{{debt.category_day}}</td>
                      <td>{{debt.start_date | dateFormat}}</td>
                      <td>{{debt.end_date | dateFormat}}</td>
                      <td v-if="debt.deleted_at == null">
                        <div class="btn-group">
                          <a :href="`/admin/debts/${debt.id}/edit`" class="btn btn-sm btn-primary" target="_blank" title="Редактировать">
                            <i class="fa fa-edit"></i>
                          </a>
                          <button @click.prevent="handleDelete(debt.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" >
                            <i class="fa fa-times-circle"></i>
                          </button>
                        </div>
                      </td>
                      <td v-if="debt.deleted_at">
                        <button @click.prevent="handleRestore(debt.id)" class="btn btn-success btn-sm " :disabled="isProcessing" >
                          {{ $t('buttons.restore') }}
                        </button>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="isProcessing">
                    <td colspan="9" class="text-center">
                      <div class='sk-wave'>
                        <div class='sk-rect sk-rect-1'></div>
                        <div class='sk-rect sk-rect-2'></div>
                        <div class='sk-rect sk-rect-3'></div>
                        <div class='sk-rect sk-rect-4'></div>
                        <div class='sk-rect sk-rect-5'></div>
                      </div>
                    </td>
                  </tr>
              </tbody>
            </table>
        </div>
    </div>

    <b-modal id="addDebt" size="lg" :title="$t('debts.add')" ref="modalAddDebt" @ok="handleStore" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')">
        <div class="form-group row">
          <div class="col">
            <label for="StoreNumber" class="col-form-label">{{ $t('debts.number') }}</label>
            <input type="text" class="form-control" v-model="debt.number" v-bind:class="{'is-invalid': errors.number }" id="StoreNumber">
            <span v-if="errors.number" class="invalid-feedback">
                <strong>{{ errors.number ? errors.number[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="storeAmount" class="col-form-label">{{ $t('debts.amount_credit') }}</label>
            <input type="text" class="form-control" v-model="debt.amount_credit" v-bind:class="{'is-invalid': errors.amount_credit }" id="storeAmount">
            <span v-if="errors.amount_credit" class="invalid-feedback">
                <strong>{{ errors.amount_credit ? errors.amount_credit[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="StoreStartDate" class="col-form-label">{{ $t('debts.start_date') }}</label>
            <input type="date" class="form-control" v-model="debt.start_date" v-bind:class="{'is-invalid': errors.start_date }" id="StoreStartDate">
            <span v-if="errors.start_date" class="invalid-feedback">
                <strong>{{ errors.start_date ? errors.start_date[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="StoreEndDay" class="col-form-label">{{ $t('debts.end_date') }}</label>
            <input type="date" class="form-control" v-model="debt.end_date" v-bind:class="{'is-invalid': errors.end_date }" id="StoreEndDay">
            <span v-if="errors.end_date" class="invalid-feedback">
                <strong>{{ errors.end_date ? errors.end_date[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="StoreFilial" class="col-form-label">{{ $t('debts.filial') }}</label>
            <input type="text" class="form-control" v-model="debt.filial" v-bind:class="{'is-invalid': errors.filial }" id="StoreFilial">
            <span v-if="errors.filial" class="invalid-feedback">
                <strong>{{ errors.filial ? errors.filial[0] : ''}}</strong>
            </span>
          </div>
          <div class="col">
            <label for="StoreNameProduce" class="col-form-label">{{ $t('debts.product_name') }}</label>
            <input type="text" class="form-control" v-model="debt.product_name" v-bind:class="{'is-invalid': errors.product_name }" id="StoreNameProduce">
            <span v-if="errors.product_name" class="invalid-feedback">
                <strong>{{errors.product_name ? errors.product_name[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <label for="StoreDelayCreditDay" class="col-form-label">{{ $t('debts.delay_credit_day') }}</label>
            <input type="text" class="form-control" v-model="debt.delay_credit_day" v-bind:class="{'is-invalid': errors.delay_credit_day }" id="StoreDelayCreditDay">
            <span v-if="errors.delay_credit_day" class="invalid-feedback">
                <strong>{{errors.delay_credit_day ? errors.delay_credit_day[0] : '' }}</strong>
            </span>
          </div>
          <div class="col">
            <label for="StoreCategoryDay" class="col-form-label">{{ $t('debts.category_day') }}</label>
            <input type="text" class="form-control" v-model="debt.category_day" v-bind:class="{'is-invalid': errors.category_day }" id="StoreCategoryDay">
            <span v-if="errors.category_day" class="invalid-feedback">
                <strong>{{ errors.category_day ? errors.category_day[0] : '' }}</strong>
            </span>
          </div>
        </div>
        <div class="form-group">
          <label for="StoreCurrentArrear" class="col-form-label">{{ $t('debts.current_arrears') }}</label>
          <input type="text" class="form-control" v-model="debt.current_arrears" v-bind:class="{'is-invalid': errors.current_arrears }" id="StoreCurrentArrear">
          <span v-if="errors.current_arrears" class="invalid-feedback">
              <strong>{{ errors.current_arrears ? errors.current_arrears[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="StoreReward" class="col-form-label">{{ $t('debts.amount_rewards') }}</label>
          <input type="text" class="form-control" v-model="debt.amount_rewards" v-bind:class="{'is-invalid': errors.amount_rewards }" id="StoreReward">
          <span v-if="errors.amount_rewards" class="invalid-feedback">
              <strong>{{ errors.amount_rewards ? errors.amount_rewards[0] : '' }}</strong>
          </span>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      debts: [],
      debt: {
        number: '',
        start_date: '',
        end_date: '',
        filial: '',
        product_name: '',
        amount_credit: '',
        delay_credit_day: '',
        category_day: '',
        current_arrears: '',
        amount_rewards: '',
      },
      payments: {},
      payment: {
        amount: '',
        payment_date: '',
        confirmed: 0,
      },
      update_debt: {},
      errors: [],
      update_errors: [],
      message: '',
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminDebtor',
    ]),
  },
  mounted() {
    this.fetchDebts();
    this.GET_ADMIN_LIST_DEBT_STATUSES();
    this.GET_ADMIN_LIST_USERS();
    this.GET_ADMIN_LIST_CONTRAGENTS();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
      'GET_ADMIN_LIST_CONTRAGENTS',
      'GET_ADMIN_LIST_DEBT_STATUSES',
      'DELETE_ADMIN_DEBT',
      'RESTORE_ADMIN_DEBT',
    ]),
    fetchDebts() {
      this.isProcessing = true;
      window.axios.get(`/admin/debtors/${this.$route.params.id}/debts`)
        .then((res) => {
          this.debts = res.data.debts;
          this.isProcessing = false;
        });
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeDebt();
      this.isProcessing = true;
    },

    handlePaymentStore(evt) {
      evt.preventDefault();
      this.storePayment();
      this.isProcessing = true;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.isProcessing = true;
          this.DELETE_ADMIN_DEBT(id)
            .then(() => {
              this.fetchDebts();
            });
        }
      }).finally(() => {
        this.isProcessing = false;
      });
    },

    handleRestore(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_restore'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.restore_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.RESTORE_ADMIN_DEBT(id)
            .then(() => {
              this.fetchDebts();
            });
        }
      }).finally(() => {
        this.isProcessing = false;
      });
    },

    storeDebt() {
      window.axios.post(`/admin/debtors/debts/${this.$route.params.id}`, this.debt)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddDebt.hide();
            this.clearModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchDebts();
          }
        })
        .catch((error) => {
          this.errors = this.laravelValidation(error);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearModal() {
      this.debt = {
        number: '',
        start_date: '',
        end_date: '',
        filial: '',
        product_name: '',
        amount_credit: '',
        delay_credit_day: '',
        category_day: '',
        current_arrears: '',
        amount_rewards: '',
      };
      this.errors = {};
    },
  },
};
</script>
